import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyInfoStateService } from '../../../contact/services/company-info-state.service';

@Component({
  selector: 'app-booking-group-event-thank-you',
  templateUrl: './booking-group-event-thank-you.component.html',
  styleUrls: ['./booking-group-event-thank-you.component.css']
})
export class BookingGroupEventThankYouComponent implements OnInit {

  constructor(
    private companyInfoStateService: CompanyInfoStateService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  onNext() {
    this.router.navigate(['/']);
  }

  get phone(): string {
    if (this.companyInfoStateService.companyInfo) {
      return this.companyInfoStateService.companyInfo.phone;
    }
    return '';
  }

}
